//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FieldErrors } from 'react-hook-form';

import {
  PostDetailsFormKey,
  PostDetailsFormValues,
} from '@universal-scheduling/contexts/scheduler/postDetailsFormProviderModels';
import { SchedulerSocialNetwork } from '@universal-scheduling/models/SocialNetworkModels';

export const getFormKey = <T extends SchedulerSocialNetwork>(
  formId: string,
  postType: T,
): PostDetailsFormKey<T> => {
  return `${postType}-${formId}`;
};

export const getErrorFromFormId = ({
  formErrors,
  formId,
  network,
}: {
  formErrors: FieldErrors<PostDetailsFormValues>;
  formId: string;
  network: SchedulerSocialNetwork;
}) => {
  return formErrors[getFormKey(formId, network)];
};
